import { TextField, MenuItem } from "@material-ui/core";
import Drawer from "../../../../../components/Drawer";
import Spinner from "react-bootstrap/Spinner";
import React from "react";

const AddCategory = ({
  setOpenDrawer,
  category,
  handleSubmitCategory,
  isAddSubCategoryLoading,
  erroName,
  handleCategoryChange,
  openDrawer,
  erroMessage,
  isPetEstablishment,
  types,
}) => {
  return (
    <Drawer
      show={openDrawer}
      onClose={() => setOpenDrawer(false)}
    >
      <form className="py-2 h-100">
        <div className="d-flex flex-column h-100">
          <span className="text-cl-black ff-univanova-medium fz-20 mb-4 d-block">Adicionar categoria</span>
          <TextField
            onChange={(event) => handleCategoryChange(event)}
            value={category?.name}
            required
            name="name"
            label={"Nome da categoria"}
            variant={"outlined"}
            error={erroName}
            className="fz-16 text-cl-dark-jungle-green ff-univanova mb-4"
          />
          {isPetEstablishment ? (
            <TextField
              select
              onChange={(event) => handleCategoryChange(event)}
              value={category?.type}
              required
              name="type"
              label={"Tipo"}
              variant={"outlined"}
              error={erroName}
              className="fz-16 text-cl-dark-jungle-green ff-univanova mb-4"
            >
              {types.map((type) => (
                <MenuItem key={type._id} value={type._id}>
                  {type.name === "service" ? "Serviços" : "Produto"}
                </MenuItem>
              ))}
            </TextField>
          ) : (
            <></>
          )}

          <p style={{ color: "red" }}>{erroMessage}</p>
        </div>
        <div className={`col-12 d-flex justify-content-end  mt-auto`}>
          <button
            onClick={() => setOpenDrawer(false)}
            className="bg-transparent border-1 me-4 rounded-2 fz-16 d-flex justify-content-center align-items-center ff-univanova-medium py-2 px-4 botton-cancel"
          >
            Cancelar
          </button>
          <button
            onClick={(e) => handleSubmitCategory(e)}
            className="btn bg-gradient-theme-blue text-white rounded-2 fz-16 d-flex justify-content-center align-items-center ff-univanova-medium py-2 px-4"
          >
            {isAddSubCategoryLoading ? (
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            ) : category._id ? (
              "Salvar"
            ) : (
              "Adicionar"
            )}
          </button>
        </div>
      </form>
    </Drawer>
  );
};

export default AddCategory;
